import React, { useState } from 'react';
import data from './data';

const App = () => {

    const [count,setCount] = useState(0)
    const [text,setText] = useState([]);

    const handleSubmit = (e) => {
        e.preventDefault()
        let amount = parseInt(count)
        setText(data.slice(0,amount))
    }
    return(
        <section className="section-center">
            <h3>Tired of boring lorem ipsum?</h3>
            <form className="lorem-form" onSubmit={handleSubmit}>
                <label htmlFor="amount">paragraphs:</label>    
                <input 
                    type="number" 
                    name="amount" 
                    id="amount" 
                    min={0} 
                    max={10} 
                    value={count}
                    onChange={(e)=>(setCount(e.target.value))}
                    />
                <button className="btn">generate</button>
            </form>   
            <article className='lorem-text'>
                {
                    text.map((item,index)=>{
                            return (
                                <p key={index}>{item}</p>
                            )
                    })
                }
                {/* {
                    text.map((item,index)=>{
                        if(index<count){

                            return (
                                <p key={index}>{item}</p>
                            )
                        }
                        return <></>
                    })
                } */}
            </article> 
        </section>
    )

}

export default App;
